import chakraTokenToVar from '@/utils/chakraTokenToVar'

function Circle({ color }: { color: string }): JSX.Element {
  return (
    <svg
      width={260}
      height={260}
      viewBox="0 0 260 260"
      fill="none"
      style={{ right: '-30px', bottom: '-210px', position: 'absolute', zIndex: 0 }}
    >
      <circle cx="130" cy="130" r="130" fill={chakraTokenToVar(color)} />
    </svg>
  )
}

function Triangle({ color }: { color: string }): JSX.Element {
  return (
    <svg
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      style={{ right: '-20px', top: '-15px', position: 'absolute', zIndex: 0 }}
    >
      <path
        d="M9.46576 60.0059L0.730634 0.463399L59.926 21.3191L9.46576 60.0059Z"
        fill={chakraTokenToVar(color)}
      />
    </svg>
  )
}

export default function Background({ color }: { color: string }): JSX.Element {
  return (
    <>
      <Triangle color={color} />
      <Circle color={color} />
    </>
  )
}
